import {
  Avatar,
  Button,
  Collapse,
  Dialog,
  DialogContent,
  DialogTitle,
  Drawer,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  IconButton,
  Radio,
  RadioGroup,
  Stack,
  TextField,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import Popover from "@mui/material/Popover";
import MainCard from "ui-component/cards/MainCard";
import { useTheme } from "@emotion/react";
import ThumbUpAltTwoToneIcon from "@mui/icons-material/ThumbUpAltTwoTone";
import ReactMarkdown from "react-markdown";
import gfm from "remark-gfm";
import axios from "axios";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import useRequestIdGenerater from "customhooks";
import ChatBubbleTwoToneIcon from "@mui/icons-material/ChatBubbleTwoTone";
import useTimeStamp from "reuseableTable/uniquetimestamp/GenerateUniqueTimeStamp";
import { Controller, FormProvider, useForm } from "react-hook-form";
import VerifiedIcon from "@mui/icons-material/Verified";
import CommentList from "./CommentList";
import ViewUploadedImages from "./ViewUploadedImages";
import AnimatedLoader from "reuseableTable/AnimatedLoader";
import LikeList from "./LikeList";
import PublicIcon from "@mui/icons-material/Public";
import WorkspacesIcon from "@mui/icons-material/Workspaces";
import GroupsIcon from "@mui/icons-material/Groups";
import EventDetails from "./EventDetails";
import moment from "moment";
import "./likejump.css";
import {
  CheckCircleOutline,
  Close,
  ReportProblemOutlined,
  SendOutlined,
} from "@mui/icons-material";
import useMessageDispatcher from "hooks/useMessageDispatcher";
import formatName from "reuseableTable/naming-convention";

const likeArray = [
  {
    type: "Like",
    emoji: "👍",
  },
  {
    type: "Celebrate",
    emoji: "👏",
  },
  {
    type: "Funny",
    emoji: "😄",
  },
  {
    type: "Love",
    emoji: "❤️",
  },
];

const FormInput = ({
  bug,
  label,
  size,
  fullWidth = true,
  name,
  required,
  ...others
}) => {
  let isError = false;
  let errorMessage = "";
  if (bug && Object.prototype.hasOwnProperty.call(bug, name)) {
    isError = true;
    errorMessage = bug[name].message;
  }

  return (
    <>
      <Controller
        name={name}
        defaultValue=""
        render={({ field }) => (
          <TextField
            fullWidth={fullWidth}
            size={size}
            label={label}
            InputLabelProps={{
              className: required ? "required-label" : "",
              required: required || false,
            }}
            error={isError}
            {...field}
          />
        )}
        {...others}
      />
      {errorMessage && (
        <Grid item xs={12}>
          <FormHelperText error>{errorMessage}</FormHelperText>
        </Grid>
      )}
    </>
  );
};

const PostDetails = ({ post, setPosts, alumniDetails, isLoading }) => {
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState(null);
  const [commentlist, setCommentList] = useState([]);
  const [openToReport, setOpenToReport] = useState(false);
  const [reportReasons, setReportReasons] = useState([]);
  const [confirmationOpen, setConfirmationOpen] = useState(false);
  const [reasonId, setReasonId] = useState("");
  const [selectedPostId, setSelectedPostId] = useState("");
  const showMessage = useMessageDispatcher();
  const RequestId = useRequestIdGenerater();
  const { rendomRequestId, generateTimeStamp } = useTimeStamp();

  const matchesXS = useMediaQuery(theme.breakpoints.down("md"));

  const [openComment, setOpenComment] = React.useState(false);
  const [openLikeList, setOpenLikeList] = useState(false);
  const [showConfetti, setShowConfetti] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [openCommentDrawer, setOpenCommentDrawer] = useState(false);

  const [jumpingEmoji, setJumpingEmoji] = useState(null);

  const handleEmojiClick = (emojiType) => {
    setJumpingEmoji(emojiType);
    setTimeout(() => {
      setJumpingEmoji(null);
    }, 700);
  };

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  const handleOpenLikeList = () => {
    setOpenLikeList(true);
  };

  const handleCloseLikeList = () => {
    setOpenLikeList(false);
  };

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  const handlePostLikes = async (id, type, like) => {
    handleEmojiClick(type);
    try {
      const response = await axios.get(
        `/v1/posts/like?like=${like}&postId=${id}&reactionType=${type}`,
        {
          headers: {
            Authorization: `Bearer ${window.localStorage.getItem(
              "serviceToken"
            )}`,
            "Content-Type": "application/json",
            requestId: RequestId(
              Math.floor(1000 + Math.random() * 9999),
              Math.floor(1000 + Math.random() * 9999 + rendomRequestId)
            ),
          },
        }
      );
      setPosts(response?.data?.data);
      generateTimeStamp();
    } catch (error) {
      generateTimeStamp();
    }
  };

  const getCommentList = async (id) => {
    try {
      const response = await axios.get(
        `/v1/posts/list/comment?postId=${id}&pageSize=200&pageNumber=0`,
        {
          headers: {
            Authorization: `Bearer ${window.localStorage.getItem(
              "serviceToken"
            )}`,
            "Content-Type": "application/json",
            requestId: RequestId(
              Math.floor(1000 + Math.random() * 9999),
              Math.floor(1000 + Math.random() * 9999 + rendomRequestId)
            ),
          },
        }
      );
      setCommentList(response?.data?.data?.content);
      generateTimeStamp();
    } catch (error) {
      generateTimeStamp();
    }
  };

  const fetchReportReasons = async () => {
    try {
      const response = await axios.get(`/v1/master/report-reason`, {
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem(
            "serviceToken"
          )}`,
          "Content-Type": "application/json",
          requestId: RequestId(
            Math.floor(1000 + Math.random() * 9999),
            Math.floor(1000 + Math.random() * 9999 + rendomRequestId)
          ),
        },
      });
      setReportReasons(response?.data?.data);
      generateTimeStamp();
    } catch (error) {
      generateTimeStamp();
    }
  };

  // const handleChangeComment = () => {
  //   setOpenComment((prev) => !prev);
  //   getCommentList(post?.id);
  // };
  const handleChangeComment = () => {
    setOpenComment(true);
    setOpenCommentDrawer(true);
    getCommentList(post?.id);
    // fetchComment(); // If you're fetching comments on demand
  };

  let commentsResult = <></>;

  if (commentlist) {
    commentsResult = commentlist.map((comment) => (
      <CommentList
        setPosts={setPosts}
        postId={post?.id}
        comment={comment}
        key={comment.id}
        userId={comment?.userId}
        openComment={openComment}
        getCommentList={getCommentList}
      />
    ));
  }

  useEffect(() => {
    generateTimeStamp();
  }, []);

  const methods = useForm({
    // resolver: yupResolver(validationSchema),
  });

  const {
    handleSubmit,
    formState: { errors },
    reset,
    watch,
  } = methods;

  const handleSubscibePost = async (postId, commentId, like) => {
    try {
      const response = await axios.get(
        `/v1/posts/like/comment?like=${like}&postId=${postId}&commentId=${commentId}&alumniId=${localStorage.getItem(
          "alumniId"
        )}`,
        {
          headers: {
            Authorization: `Bearer ${window.localStorage.getItem(
              "serviceToken"
            )}`,
            "Content-Type": "application/json",
            requestId: RequestId(
              Math.floor(1000 + Math.random() * 9999),
              Math.floor(1000 + Math.random() * 9999 + rendomRequestId)
            ),
          },
        }
      );
      getCommentList(postId);
      setPosts(response?.data?.data);
      generateTimeStamp();
    } catch (error) {
      console.error("Failed to fetch data:", error);
    }
  };

  const commentValue = watch("name", "");
  const onSubmit = async (comment) => {
    // handleChangeComment();
    const payload = {
      comment: comment?.name,
      commentId: "",
    };
    try {
      const response = await axios.post(
        `/v1/posts/add/comment?postId=${post?.id
        }&alumniId=${localStorage.getItem("alumniId")}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${window.localStorage.getItem(
              "serviceToken"
            )}`,
            "Content-Type": "application/json",
            requestId: RequestId(
              Math.floor(1000 + Math.random() * 9999),
              Math.floor(1000 + Math.random() * 9999 + rendomRequestId)
            ),
          },
        }
      );
      setPosts(response?.data?.data);
      getCommentList(post?.id);
      reset();
      generateTimeStamp();
    } catch (error) {
      generateTimeStamp();
    }
  };
  const handleReport = async (postId, reasonId) => {
    try {
      const response = await axios.get(
        `/v1/posts/report/post?postId=${postId}&reasonId=${reasonId}`,
        {
          headers: {
            Authorization: `Bearer ${window.localStorage.getItem(
              "serviceToken"
            )}`,
            "Content-Type": "application/json",
            requestId: RequestId(
              Math.floor(1000 + Math.random() * 9999),
              Math.floor(1000 + Math.random() * 9999 + rendomRequestId)
            ),
          },
        }
      );
      if (response.status === 200) {
        generateTimeStamp();
        if (response.data.code !== "403") {
          setReasonId("");
          setOpenToReport(false);
          setConfirmationOpen(true);
        }
      }
    } catch (error) {
      generateTimeStamp();
      setReasonId("");
      if (!error.response) {
        showMessage({ message: error.message, color: "error" });
      } else {
        showMessage({ message: error.response.data.Msg, color: "error" });
      }
    }
  };

  return (
    <>
      <MainCard>
        {isLoading ? (
          <>
            <AnimatedLoader />
          </>
        ) : (
          <>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Grid container wrap="nowrap" alignItems="center" spacing={1}>
                  <Grid item>
                    <Avatar
                      alt={formatName(post?.alumniMemberMini?.name)}
                      src={
                        post?.alumniMemberMini?.avatar?.data
                          ? `data:image/png;base64,${post?.alumniMemberMini?.avatar?.data}`
                          : undefined
                      }
                      sx={{
                        border: post?.alumniMemberMini?.starAlumni
                          ? "3px solid #D89E46"
                          : "none",
                      }}
                    >
                      {" "}
                      {!post?.alumniMemberMini?.avatar?.data &&
                        formatName(post?.alumniMemberMini?.name.charAt(0))}
                    </Avatar>
                  </Grid>
                  <Grid item xs zeroMinWidth>
                    <Grid container direction="column">
                      <Grid item>
                        <Grid container alignItems="center" spacing={1}>
                          <Grid item>
                            <Typography
                              align="left"
                              variant="h5"
                              component="div"
                              sx={{
                                display: "inline-flex",
                                alignItems: "center",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {post?.alumniMemberMini
                                ? formatName(post?.alumniMemberMini?.name)
                                : formatName(post?.createdByName)}
                              {post?.alumniMemberMini?.starAlumni && (
                                <VerifiedIcon
                                  sx={{
                                    color: "#D89E46",
                                    fontSize: "18px",
                                    marginLeft: "4px",
                                  }}
                                />
                              )}
                            </Typography>
                          </Grid>
                          <Grid item>
                            {post?.postsFor === "EveryOne" ? (
                              <PublicIcon />
                            ) : post?.postsFor === "Batch" ? (
                              <WorkspacesIcon />
                            ) : (
                              <GroupsIcon />
                            )}
                          </Grid>
                          <Grid item>
                            <Typography align="left" variant="caption">
                              {moment(post.createdAt).format("DD/MM/YYYY")}
                            </Typography>
                          </Grid>
                        </Grid>
                      </Grid>

                      {/* Batch, Branch, Department */}
                      <Grid item>
                        <Typography
                          align="left"
                          variant="caption"
                          color="textSecondary"
                        >
                          Batch {post?.alumniMemberMini?.batchTag}
                          {post?.alumniMemberMini?.institutionsBranchName && (
                            <>
                              {" "}
                              | Campus{" "}
                              {post?.alumniMemberMini?.institutionsBranchName}
                            </>
                          )}
                          {post?.alumniMemberMini?.department && (
                            <> | {post?.alumniMemberMini?.department}</>
                          )}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item></Grid>
                </Grid>
              </Grid>

              <Grid>
                <Grid
                  item
                  xs={12}
                  p={1}
                  sx={{
                    "& > p": {
                      ...theme.typography.body1,
                      mb: 0,
                    },
                  }}
                >
                  <ReactMarkdown remarkPlugins={[gfm]}>
                    {post.postText}
                  </ReactMarkdown>

                  {post && post?.postText.includes("youtube.com/watch?v=") && (
                    <div style={{ marginTop: 16 }}>
                      <iframe
                        width="100%"
                        height="315"
                        src={`https://www.youtube.com/embed/${post?.postText.split("v=")[1].split("&")[0]
                          }`}
                        title="YouTube video preview"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                      ></iframe>
                    </div>
                  )}
                </Grid>

                {post.images && post.images.length > 0 && (
                  <Grid item xs={12}>
                    <ViewUploadedImages
                      postId={post?.id}
                      itemData={post?.images}
                    />
                  </Grid>
                )}

                {post?.eventPost && (
                  <Grid mt={2}>
                    <EventDetails
                      setShowConfetti={setShowConfetti}
                      setPosts={setPosts}
                      showConfetti={showConfetti}
                      post={post}
                    />
                  </Grid>
                )}

                <Grid item xs={12}>
                  <Grid
                    container
                    alignItems="center"
                    justifyContent="space-between"
                    spacing={2}
                    sx={{
                      mt: 0,
                      color:
                        theme.palette.mode === "dark" ? "grey.700" : "grey.800",
                    }}
                  >
                    <Grid item>
                      {post?.reactionCount && (
                        <div
                          style={{
                            width: "100px",
                            display: "flex",
                          }}
                        >
                          {Object.entries(post?.reactionCount).map(
                            ([key, value]) => {
                              const emojiItem = likeArray.find(
                                (item) => item.type === key
                              );
                              return (
                                <div
                                  key={key}
                                  className={
                                    jumpingEmoji === emojiItem?.type
                                      ? "jumping"
                                      : ""
                                  }
                                  onClick={handleOpenLikeList}
                                  onMouseEnter={(e) => {
                                    e.target.style.borderBottom =
                                      "1px solid black";
                                  }}
                                  onMouseLeave={(e) => {
                                    e.target.style.borderBottom =
                                      "1px solid transparent";
                                  }}
                                >
                                  {emojiItem?.emoji}
                                </div>
                              );
                            }
                          )}
                        </div>
                      )}

                      <Stack direction="row" spacing={2}>
                        <Button
                          variant="text"
                          onClick={() =>
                            handlePostLikes(
                              post?.id,
                              "Like",
                              !post?.postLikesIds?.includes(
                                localStorage.getItem("userId")
                              )
                                ? true
                                : false
                            )
                          }
                          color="inherit"
                          size="small"
                          onMouseEnter={handlePopoverOpen}
                        //   onMouseLeave={handlePopoverClose} // Close popover when mouse leaves the button
                        >
                          <ThumbUpAltTwoToneIcon
                            sx={{ fontSize: "18px" }}
                            color={
                              post?.postLikesIds?.includes(
                                localStorage.getItem("userId")
                              )
                                ? "primary"
                                : "inherit"
                            }
                          />

                          <Typography
                            color="inherit"
                            sx={{
                              fontWeight: 500,
                              fontSize: "13.5px",
                              ml: 0.5,
                              display: { xs: "none", sm: "block" },
                            }}
                          >
                            {post?.likes}
                          </Typography>
                          <Typography
                            color="inherit"
                            sx={{
                              fontWeight: 500,
                              fontSize: "13.5px",
                              ml: 0.5,
                              display: { xs: "none", sm: "block" },
                            }}
                          >
                            {post?.likes > 1 ? "likes" : "like"}
                          </Typography>
                        </Button>
                        {!post?.postLikesIds?.includes(
                          localStorage.getItem("userId")
                        ) && (
                            <Popover
                              open={open}
                              anchorEl={anchorEl}
                              onMouseLeave={handlePopoverClose}
                              onClose={handlePopoverClose}
                              anchorOrigin={{
                                vertical: "top",
                                horizontal: "center",
                              }}
                              transformOrigin={{
                                vertical: "bottom",
                                horizontal: "center",
                              }}
                              disableRestoreFocus
                            >
                              <Stack direction="row" spacing={1} p={1}>
                                {likeArray?.map((like, index) => (
                                  <Typography
                                    key={index}
                                    sx={{
                                      cursor: "pointer",
                                      fontWeight: isHovered ? 500 : 400,
                                    }}
                                    variant={isHovered ? "h1" : "h3"}
                                    onMouseEnter={handleMouseEnter}
                                    onMouseLeave={handleMouseLeave}
                                    onClick={() =>
                                      handlePostLikes(
                                        post?.id,
                                        like?.type,
                                        !post?.postLikesIds?.includes(
                                          localStorage.getItem("userId")
                                        )
                                          ? true
                                          : false
                                      )
                                    }
                                  >
                                    {like.emoji}
                                  </Typography>
                                ))}
                              </Stack>
                            </Popover>
                          )}
                        <Button
                          onClick={handleChangeComment}
                          size="small"
                          variant="text"
                          color="inherit"
                          startIcon={
                            <ChatBubbleTwoToneIcon color="secondary" />
                          }
                        >
                          {post?.comments}{" "}
                          {post?.comments > 1 ? "comments" : "comment"}
                        </Button>

                        {localStorage.getItem("userId") !== post?.userId && (
                          <Button
                            onClick={() => {
                              setOpenToReport(true);
                              fetchReportReasons();
                              setSelectedPostId(post?.id);
                            }}
                            size="small"
                            color="error"
                            startIcon={
                              <ReportProblemOutlined
                                fontSize="small"
                                color="error"
                              />
                            }
                          >
                            Report
                          </Button>
                        )}
                      </Stack>
                    </Grid>

                    {openLikeList && (
                      <LikeList
                        post={post}
                        postId={post?.id}
                        open={openLikeList}
                        handleClose={handleCloseLikeList}
                      />
                    )}
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            {post?.aiChecked && (
              <Grid display="flex" justifyContent="flex-end">
                <Stack
                  direction="row"
                  alignItems="center"
                  flex="end"
                  spacing={1}
                >
                  <AutoAwesomeIcon sx={{ color: "#4d8ffd" }} />
                  <Typography variant="caption">Verified by AI</Typography>
                </Stack>
              </Grid>
            )}
            {openToReport && (
              <Dialog open={openToReport} fullWidth maxWidth="sm">
                <DialogTitle
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Typography variant="h5">Report</Typography>
                  <Tooltip title="Close">
                    <IconButton
                      onClick={() => {
                        setOpenToReport(false);
                        setReasonId("");
                      }}
                      size="small"
                    >
                      <Close />
                    </IconButton>
                  </Tooltip>
                </DialogTitle>
                <Typography
                  textAlign="center"
                  sx={{
                    color: "#4F4F4F",
                    fontSize: "16px",
                    fontWeight: 600,
                    padding: "0 16px",
                  }}
                >
                  Why are you reporting this post?
                </Typography>
                <Typography
                  textAlign="center"
                  sx={{ fontSize: "13px", fontWeight: 500, padding: "0 16px" }}
                >
                  Please select a reason for reporting this post. Your feedback
                  is important to us.
                </Typography>
                <DialogContent>
                  <FormControl component="fieldset">
                    <RadioGroup
                      value={reasonId}
                      onChange={(e) => setReasonId(e.target.value)}
                    >
                      {reportReasons?.map((reason, index) => (
                        <FormControlLabel
                          key={index}
                          value={reason?.id}
                          control={<Radio />}
                          label={reason?.name}
                        />
                      ))}
                    </RadioGroup>
                  </FormControl>
                </DialogContent>
                <Button
                  sx={{ borderRadius: "0px" }}
                  onClick={() => handleReport(selectedPostId, reasonId)}
                  color="error"
                  variant="contained"
                  disabled={!reasonId}
                >
                  Submit
                </Button>
              </Dialog>
            )}
            {!openToReport && confirmationOpen && (
              <Dialog open={confirmationOpen} fullWidth maxWidth="xs">
                <DialogTitle
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    color: "#4F4F4F",
                  }}
                >
                  Feedback Submitted
                  <IconButton
                    onClick={() => setConfirmationOpen(false)}
                    size="small"
                  >
                    <Close sx={{ color: "#4F4F4F" }} />
                  </IconButton>
                </DialogTitle>

                <DialogContent
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    textAlign: "center",
                    color: "#4F4F4F",
                    p: 3,
                  }}
                >
                  <CheckCircleOutline
                    sx={{ fontSize: 60, color: "green", mb: 2 }}
                  />
                  <Typography variant="h5">
                    Thank you for your feedback!
                  </Typography>
                  <Typography variant="body2">
                    We appreciate your time in reporting this. Our team will
                    review the content and take appropriate action as needed.
                  </Typography>
                </DialogContent>
                <Button
                  onClick={() => setConfirmationOpen(false)}
                  sx={{
                    borderRadius: "0px",
                    backgroundColor: "#2E7D32",
                    color: "#fff",
                    "&:hover": { backgroundColor: "#1B5E20" },
                  }}
                  variant="contained"
                >
                  OK
                </Button>
              </Dialog>
            )}
          </>
        )}
      </MainCard>

      <Drawer
        anchor="right"
        open={openCommentDrawer}
        onClose={() => setOpenCommentDrawer(false)}
        PaperProps={{
          sx: {
            width: { xs: "100%", sm: 500 },
            p: 2,
            borderTopLeftRadius: 10,
            borderBottomLeftRadius: 10,
          },
        }}
      >
        {openComment && (
          <Grid item xs={12} sx={{ pt: 2 }}>
            <form onSubmit={handleSubmit(onSubmit)}>
              <Grid container spacing={2} alignItems="flex-start">
                <Grid item sx={{ display: { xs: "none", sm: "block" } }}>
                  <Avatar
                    sx={{ mt: 0.75 }}
                    alt="User 1"
                    src={`data:image/*;base64, ${alumniDetails?.avatar?.data}`}
                    size="xs"
                  />
                </Grid>
                <Grid item xs zeroMinWidth>
                  <FormProvider {...methods}>
                    <FormInput
                      fullWidth
                      name="name"
                      label="Write a comment..."
                      size={matchesXS ? "small" : "medium"}
                      bug={errors}
                    />
                  </FormProvider>
                </Grid>
                <Grid item>
                  {/* <AnimateButton> */}
                  <IconButton
                    type="submit"
                    variant="contained"
                    color="secondary"
                    disabled={!commentValue}
                    size={matchesXS ? "small" : "large"}
                    sx={{ mt: 0.5 }}
                  >
                    <SendOutlined />
                  </IconButton>
                </Grid>
              </Grid>
            </form>
          </Grid>
        )}
        {commentsResult}
      </Drawer>
    </>
  );
};

export default PostDetails;
